import { TIntegration } from '@/core/modules/integrations/integrations'
import { TIntegrationProvider } from '@/core/store/Integrations/integrations.store'

export const transformProviderObject = (
    integration: TIntegration
): TIntegrationProvider => {
    return {
        id: integration.id,
        displayName: integration.display_name,
        type: integration.type,
        integrationMode: integration.integration_mode,
        loading: false,
        integrations: [integration],
        integrationEventData: null,
    }
}
